import { StationPageWrapper } from '@app/core/routing/StationPageWrapper';
import { FragmentsListPage } from './FragmentsListPage';

export function FragmentsListStationPage() {
  return (
    <StationPageWrapper>
      <FragmentsListPage />
    </StationPageWrapper>
  );
}
